<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-full mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center px-20">
          <span class="font-bold text-gray-900 text-lg">Configuraciones</span>
        </div>

        <div class="w-5/6 mx-auto">
          <form class="w-full" id="configForm" @submit.prevent>
            <div class="flex items-center">
              <div class="flex flex-col items-start w-2/6">
                <label
                  for="logo"
                  class="block text-sm font-medium leading-6 text-gray-900 font-semibold"
                  >Logo del sitio:</label
                >
                <div class="relative w-20 lg:w-40 h-20 lg:h-40">
                  <img
                    :src="replaceURL(imageURL)"
                    class="h-full w-full object-cover mt-1 rounded-full"
                    alt
                  />
                  <div
                    class="absolute cursor-pointer right-0 bottom-0 flex items-center justify-center p-2 rounded-full border-4 border-gray-500 bg-gray-700 text-gray-100 hover:bg-gray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6 fill-current"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
                      />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                    <input
                      @change="changeImage"
                      class="cursor-pointer bottom-0 right-0 w-10 h-10 absolute block opacity-0"
                      type="file"
                      ref="image"
                      name="image"
                      accept="image/png, image/jpeg"
                    />
                  </div>
                </div>
              </div>
              <div class="flex w-4/6 flex-col text-left">
                <div class="w-full">
                  <label
                    for="app_name"
                    class="block text-sm font-medium leading-6 text-gray-900 font-semibold"
                    >Nombre de la plataforma:</label
                  >
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    type="text"
                    name="app_name"
                    id="app_name"
                    v-model="app_name"
                  />
                </div>
                <div class="w-full">
                  <label
                    for="max_project_questions"
                    class="block text-sm font-medium leading-6 text-gray-900 font-semibold"
                    >Límite de preguntas en cuestionarios:</label
                  >
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    type="number"
                    name="max_project_questions"
                    id="max_project_questions"
                    v-model.number="max_project_questions"
                  />
                </div>
                <div class="w-full">
                  <label
                    for="max_question_options"
                    class="block text-sm font-medium leading-6 text-gray-900 font-semibold"
                    >Límite de opciones por pregunta:</label
                  >
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    type="number"
                    name="max_question_options"
                    id="max_question_options"
                    v-model.number="max_question_options"
                  />
                </div>
                <div class="w-full mb-2">
                  <label
                    for="color_principal"
                    class="block text-sm leading-6 text-gray-900 font-semibold"
                    >Color principal:</label
                  >
                  <vue-color-picker
                    v-model="color_principal"
                    :showAlpha="false"
                  />
                </div>
                <div class="w-full mb-2">
                  <label
                    for="color_secundario"
                    class="block text-sm leading-6 text-gray-900 font-semibold"
                    >Color secundario:</label
                  >
                  <vue-color-picker
                    v-model="color_secundario"
                    :showAlpha="false"
                  />
                </div>
                <div class="w-full mb-2">
                  <label
                    for="color_terciario"
                    class="block text-sm leading-6 text-gray-900 font-semibold"
                    >Color complementario:</label
                  >
                  <vue-color-picker
                    v-model="color_terciario"
                    :showAlpha="false"
                  />
                </div>
              </div>
            </div>
            <span class="block text-sm leading-6 text-gray-900 font-semibold"
              >Arrastra el mapa para señalar la zona inicial</span
            >
            <div class="w-full flex">
              <div class="w-1/4 text-left mx-auto">
                <label
                  for="lat"
                  class="block text-sm font-medium leading-6 text-gray-900"
                  >Latitud:</label
                >
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  type="text"
                  name="lat"
                  id="lat"
                  v-model="userCenter.lat"
                  disabled
                />
              </div>
              <div class="w-1/4 text-left mx-auto">
                <label
                  for="lng"
                  class="block text-sm font-medium leading-6 text-gray-900"
                  >Longitud:</label
                >
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  type="text"
                  name="lng"
                  id="lng"
                  v-model="userCenter.lng"
                  disabled
                />
              </div>
              <div class="w-1/4 text-left mx-auto">
                <label
                  for="zoom"
                  class="block text-sm font-medium leading-6 text-gray-900"
                  >Zoom:</label
                >
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  type="text"
                  name="zoom"
                  id="zoom"
                  v-model="userZoom"
                  disabled
                />
              </div>
            </div>
            <div class="w-full h-96">
              <l-map
                ref="minimap"
                @ready="onReady()"
                class="h-full w-full z-0"
                :zoom="zoom"
                :minZoom="minZoom"
                :maxZoom="maxZoom"
                :center="center"
                :options="{ zoomControl: true, tap: false }"
                @update:zoom="zoomUpdated"
                @update:center="centerUpdated"
              >
                <l-tile-layer
                  :url="urlBasemap"
                  :attribution="attribution"
                ></l-tile-layer>
              </l-map>
            </div>
            <div class="flex justify-end">
              <btn-action
                @click="updateConfiguration()"
                class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
                :colorT="bd_colorT"
              >
                Guardar
              </btn-action>
            </div>
          </form>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Configuración guardada exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import AlertDialog from "./AlertDialog";
import urlMixin from "@/mixins/urlMixin";
import { styled } from "@egoist/vue-emotion";
import { LMap, LTileLayer } from "vue2-leaflet";

const BtnAction = styled("button")`
  color: ${(props) => props.colorT};
  border-color: ${(props) => props.colorT};
  &.bg-selected {
    background-color: ${(props) => props.colorT};
    color: #fff;
  }
  &:hover {
    background-color: ${(props) => props.colorT};
  }
`;

export default {
  mixins: [urlMixin],
  name: "config-list",
  data() {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      url_image: "",
      color_principal: "",
      color_secundario: "",
      color_terciario: "",
      id: 0,
      bd_colorT: "",
      imageURL: "",
      showingSuccess: false,
      showingError: false,
                app_name: "",
                max_project_questions: 0, // New configuration field
                max_question_options: 0, // New configuration field for options
                zoom: 4,
                minZoom: 2,      maxZoom: 9,
      center: { lat: 24.201295517553916, lng: -91.43722389375776 },
      map: null,
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      userCenter: null,
      userZoom: null,
    };
  },
  components: {
    AlertDialog,
    BtnAction,
    LMap,
    LTileLayer,
  },
  beforeMount() {
    this.fetchConfiguration();
  },
  methods: {
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then((response) => {
          // removed console log
          let conf = response.data.config;
          this.url_image = conf.url_imagen;
          this.imageURL = conf.url_imagen;
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
          this.bd_colorT = conf.color_terciario;
          this.id = conf.id;
          this.app_name = conf.app_name;
          this.max_project_questions = conf.max_project_questions; // Populate new config field
          this.max_question_options = conf.max_question_options; // Populate new config field for options
          if (conf.latitud !== null) {
            this.center = {
              lat: conf.latitud,
              lng: conf.longitud,
            };
            this.zoom = conf.zoom;
          }
          this.userCenter = {
            lat: conf.latitud,
            lng: conf.longitud,
          };
          this.userZoom = conf.zoom;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    updateConfiguration() {
      const form = document.getElementById("configForm");
      const formData = new FormData(form);

      const event_image = formData.get("image");

      formData.set("image", event_image);
      formData.append("id", this.id);

      if (this.url_image === this.imageURL) {
        formData.append("url_image", this.url_image);
      }

      formData.append("color_principal", this.color_principal);
      formData.append("color_secundario", this.color_secundario);
      formData.append("color_terciario", this.color_terciario);

                formData.append("latitud", this.userCenter.lat);
                formData.append("longitud", this.userCenter.lng);
                          formData.append("zoom", this.userZoom);
                
                          this.axios        .post("apidev/api/config/site/update", formData, this.config)
        .then((response) => {
          // removed console log
          this.showingSuccess = true;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = true;
        });
    },
    changeImage: function (event) {
      let file = event.target.files[0];
      this.imageURL = URL.createObjectURL(file);
      this.image = this.$refs.image.files[0];
    },

    onReady() {
      this.$nextTick(() => {
        this.map = this.$refs.minimap.mapObject;
      });
    },
    zoomUpdated(zoom) {
      this.userZoom = zoom;
    },
    centerUpdated(center) {
      this.userCenter = center;
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
